import { render, staticRenderFns } from "./ValidationReport.vue?vue&type=template&id=2525402a&scoped=true"
import script from "./ValidationReport.vue?vue&type=script&lang=js"
export * from "./ValidationReport.vue?vue&type=script&lang=js"
import style0 from "./ValidationReport.vue?vue&type=style&index=0&id=2525402a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525402a",
  null
  
)

export default component.exports